module.exports = __webpack_public_path__ + "media/images/ui__arrowUp--dark-f0a9e9ed523318455fa71a0679f952e8.png";